import { useMemo } from 'react';

import { useSessionAsync } from 'src/app/shared/hooks/session';
import { useSessionConfiguration } from 'src/app/shared/hooks/sessionConfiguration';
import { isLoaded } from 'src/app/shared/utils/async';

import { type HeaderNavLink, useHeaderNavLinks } from '../../../../shared/hooks';

type Result = ModelHookResult<{
	showMenu: boolean;
	userIdentified: boolean;
	navLinks: readonly HeaderNavLink[];
}>;

export function useHeader(): Result {
	const { featureConfigs } = useSessionConfiguration();
	const session = useSessionAsync();

	const navLinks = useHeaderNavLinks();

	const isMembershipEnabled = featureConfigs.membershipEnabled;

	return {
		data: {
			showMenu: isLoaded(session),
			userIdentified: isLoaded(session) && session.value.loginState !== 'GUEST',
			navLinks: useMemo(
				() => [
					//
					navLinks.myPetitions,
					...(isMembershipEnabled ? [navLinks.membership] : []),
					navLinks.search,
				],
				[isMembershipEnabled, navLinks],
			),
		},
	};
}
